import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import HotSites from './components/HotSites';
import FeaturedArticles from './components/FeaturedArticles';
import BrandStats from './components/BrandStats';
import LatestArticles from './components/LatestArticles';
import CTASection from './components/CTASection';
import { OrganizationSchema, WebsiteSchema, WebPageSchema, getPageSEO } from '@/components/base/SEO';

const homeSEO = {
  title: '51网址导航 | 网址导航大全与百万网址导航 | 导航网站最新地址 吃瓜爆料每日更新',
  description: '51网址导航网🌟汇集网址导航大全、百万网址导航等主流导航入口，同步推送最新网红黑料、明星塌房现场及独家爆料视频，实时追踪每日热点。',
  keywords: '网址导航大全,百万网址导航,51网址导航,网址导航,导航网站,吃瓜爆料,每日黑料,最新地址',
  canonicalUrl: 'http://chiguadao.cn/',
};

export default function Home() {
  useEffect(() => {
    document.title = homeSEO.title;

    const setMeta = (name: string, content: string, prop?: string) => {
      let el: HTMLMetaElement | null;
      if (prop) {
        el = document.querySelector(`meta[property="${prop}"]`);
      } else {
        el = document.querySelector(`meta[name="${name}"]`);
      }
      if (el) {
        el.setAttribute('content', content);
      }
    };

    setMeta('description', homeSEO.description);
    setMeta('keywords', homeSEO.keywords);
    setMeta('og:title', homeSEO.title);
    setMeta('og:description', homeSEO.description);
    setMeta('og:url', homeSEO.canonicalUrl);
    setMeta('twitter:title', homeSEO.title);
    setMeta('twitter:description', homeSEO.description);

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', homeSEO.canonicalUrl);

    const existingScript = document.getElementById('schema-jsonld');
    if (existingScript) existingScript.remove();

    const schemaJson = getPageSEO({
      ...homeSEO,
      ogType: 'website',
      schema: WebPageSchema(homeSEO.title, homeSEO.canonicalUrl, homeSEO.description),
    });

    if (schemaJson) {
      const script = document.createElement('script');
      script.id = 'schema-jsonld';
      script.type = 'application/ld+json';
      script.textContent = schemaJson;
      document.head.appendChild(script);
    }

    const orgScript = document.getElementById('org-schema');
    if (!orgScript) {
      const orgJson = JSON.stringify(OrganizationSchema());
      const s = document.createElement('script');
      s.id = 'org-schema';
      s.type = 'application/ld+json';
      s.textContent = orgJson;
      document.head.appendChild(s);
    }

    const wsScript = document.getElementById('ws-schema');
    if (!wsScript) {
      const wsJson = JSON.stringify(WebsiteSchema());
      const s = document.createElement('script');
      s.id = 'ws-schema';
      s.type = 'application/ld+json';
      s.textContent = wsJson;
      document.head.appendChild(s);
    }
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <HotSites />
        <FeaturedArticles />
        <BrandStats />
        <LatestArticles />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}